export default __webpack_public_path__ + "static/media/Category_BuildingandConstruction_135x195.db568252.jpg";